import { render, staticRenderFns } from "./aboutNews.vue?vue&type=template&id=2e96d060&scoped=true&"
import script from "./aboutNews.vue?vue&type=script&lang=js&"
export * from "./aboutNews.vue?vue&type=script&lang=js&"
import style0 from "./aboutNews.vue?vue&type=style&index=0&id=2e96d060&prod&lang=less&scoped=true&"
import style1 from "./aboutNews.vue?vue&type=style&index=1&id=2e96d060&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e96d060",
  null
  
)

export default component.exports